import {db} from "../../firebase";
import firebase from "firebase/compat/app";
import {createId} from "../../helpers/misc";
import {Collections} from "../collections";
import {CompanyRmI} from "../../db/models/company/rm";

export const getStepsRms = () => {
    return db.collection(Collections.COMPANY_RMS)
        .where("companyId", "==", "61DY1lgX02WwNmxy7jLwnA2lkCh1")
        .get()
        .then(snapshot => {
            if (!snapshot.docs) return [];
            const rms: CompanyRmI[] = snapshot.docs.map(doc => doc.data() as CompanyRmI)
            return rms;
        });
}

export const getRms = () => {
    return db.collection(Collections.COMPANY_RMS)
        .get()
        .then(snapshot => {
            if (!snapshot.docs) return [];
            const rms: CompanyRmI[] = snapshot.docs.map(doc => doc.data() as CompanyRmI)
            return rms;
        });
}

export const addRmGroup = (rmId: string, groupName: string) => {
    if (!rmId || !groupName) return Promise.resolve(null);
    const groupId = createId();
    const group = {
        id: groupId,
        name: groupName,
        studentIds: []
    };

    return db.collection(Collections.COMPANY_RMS).doc(rmId).update(`groups.${groupId}`, group);
}

export const editRmGroupMembers = (rmId: string, groupId: string, studentIds: string[]) => {
    if (!rmId || !groupId || !studentIds) return Promise.resolve(null);

    return db.collection(Collections.COMPANY_RMS).doc(rmId).update(`groups.${groupId}.studentIds`, studentIds);
}

export const editRmGroupName = (rmId: string, groupId: string, groupName: string) => {
    if (!rmId || !groupId || !groupName) return Promise.resolve(null);

    return db.collection(Collections.COMPANY_RMS).doc(rmId).update(`groups.${groupId}.name`, groupName);
}

export const deleteRmGroup = (rmId: string, groupId: string) => {
    if (!rmId || !groupId) return Promise.resolve(null);

    return db.collection(Collections.COMPANY_RMS).doc(rmId).update(`groups.${groupId}`, firebase.firestore.FieldValue.delete());
}